/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        Bot: 'Bot',// '상담을 원하시는군요.<br>아래 버튼을 누르면<br>카카오 상담톡으로 연결해드릴게요.',
        Kakao: 'Kakao',// '카카오 상담톡으로 상담하기',
        Info: 'Info',
    },
    tomy:{
        kr: {
            Bot: '상담을 원하시는군요. 카카오 상담톡으로 행복센터 매니저님을 연결해드릴까요?',
            Kakao: '행복센터 매니저와 상담하기',
            Info: '흠. 꼭 찾아야 하는게 있는 것 같네요!<br>그렇다면 행복센터 매니저와 이야기 해보시는게 어떨까요??',
        },
        eng: {
            Bot: 'You would like a consultation. May I connect you to the manager of the Customer Support Center through KakaoTalk?',
            Kakao: 'Consult with the manager of the Customer Support Center',
            Info: `Well, I think there's something you have to find. Then why don't you talk to the manager of Center? Customer Center is at <a class="tel" href="tel:1544-8580">1544-8580</a>.`,
        }
    },
    papa:{
        kr: {
            Bot: '상담이 필요한가요? 그럼 우리 행복센터 매니저님과 이야기해보는 게 제일 좋을 거예요. 카카오 상담톡으로 연결해줄게요.',
            Kakao: '카카오 상담톡으로 상담하기',
            Info: '흠. 꼭 찾아야 하는게 있는 것 같네요!<br>그렇다면 행복센터 매니저와 이야기 해보시는게 어떨까요??',
        },
        eng: {
            Bot: 'Do you need a consultation? Then it would be best to talk with the manager of our Customer Support Center. I will connect you through KakaoTalk.',
            Kakao: 'Consult with the manager of the Customer Support Center',
            Info: '흠. 꼭 찾아야 하는게 있는 것 같네요!<br>그렇다면 행복센터 매니저와 이야기 해보시는게 어떨까요??',
        }
    },
};
